import { createFileRoute, redirect } from '@tanstack/react-router'
import { isPlanTab } from '@/modules/launch/plan/tabs'

/**
 * The plan page's tabs as real URLs — `/scenarios/diagnosis`, `/scenarios/explore`.
 *
 * A sibling route (trailing underscore) rather than a nested one, so `/scenarios`
 * keeps working on its own and stays a leaf. The static `/scenarios/edit` route
 * outranks this dynamic segment, so it is unaffected.
 *
 * An unknown segment redirects to the bare page instead of rendering an empty
 * tab bar, so a stale or hand-typed link lands somewhere real.
 */
export const Route = createFileRoute('/$orgSlug/$clientSlug/scenarios_/$tab')({
  beforeLoad: ({ params }) => {
    if (!isPlanTab(params.tab)) {
      throw redirect({
        to: '/$orgSlug/$clientSlug/scenarios',
        params: { orgSlug: params.orgSlug, clientSlug: params.clientSlug },
      })
    }
  },
})
